import { useMutation } from '@tanstack/react-query';
import type {
  AgentApiCandidateImportRequestsRecord,
  SharedCsvFieldMapping,
  SharedCsvNameMapping,
  SharedCsvDefaultMapping,
} from '@/types/serializers';

interface UpdateCandidateImportRequestParams {
  encryptId: string;
  field_mappings: SharedCsvFieldMapping[];
  name_mappings: SharedCsvNameMapping[];
  default_mappings: SharedCsvDefaultMapping[];
  organization_user_id?: number | null;
}

export const useUpdateCandidateImportRequest = () => {
  return useMutation({
    mutationFn: async (params: UpdateCandidateImportRequestParams) => {
      const { encryptId, ...body } = params;

      const response = await fetch(`/agent/api/candidate_import_requests/${encryptId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token':
            document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content || '',
        },
        body: JSON.stringify(body),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ message: '更新に失敗しました' }));
        throw new Error(errorData.message || '更新に失敗しました');
      }

      const data: AgentApiCandidateImportRequestsRecord = await response.json();
      return data;
    },
  });
};
